"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ReceiptPreview = _interopRequireDefault(require("./components/ReceiptPreview.vue"));
var _rsManagement = require("@/api/rsManagement");
var _templateStore = require("./utils/templateStore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ReceiptTemplateEditor',
  components: {
    ReceiptPreview: _ReceiptPreview.default
  },
  data: function data() {
    return {
      config: {},
      pageReady: false,
      saving: false,
      isCreate: false,
      isCopy: false,
      activePanels: ['base', 'title', 'order', 'goods', 'footer'],
      sceneOptions: _templateStore.SCENE_OPTIONS,
      mockData: _templateStore.mockReceiptData
    };
  },
  computed: {
    pageTitle: function pageTitle() {
      if (this.isCopy) return '复制小票模板';
      return this.isCreate ? '新增小票模板' : '编辑小票模板';
    }
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.pageTitle;
      this.$route.meta.title = title;
      this.$store.dispatch('tagsView/updateVisitedView', _objectSpread(_objectSpread({}, this.$route), {}, {
        title: title
      }));
    },
    initData: function initData() {
      var _this = this;
      var id = this.$route.params.id;
      var copyFrom = this.$route.query.copyFrom;
      this.isCreate = id === 'new';
      this.isCopy = this.isCreate && !!copyFrom;
      this.setTagsViewTitle();
      if (id === 'new') {
        this.isCreate = true;
        if (copyFrom) {
          (0, _rsManagement.getTicketTemplateInfo)(copyFrom).then(function (res) {
            var mapped = (0, _templateStore.mapApiToEditor)(res || {});
            var copyName = "".concat(mapped.templateName || mapped.name || '模板', "\u526F\u672C");
            _this.config = _objectSpread(_objectSpread({}, mapped), {}, {
              id: undefined,
              isDefault: false,
              name: copyName,
              templateName: copyName
            });
            _this.pageReady = true;
          }).catch(function () {
            _this.$message.error('复制的模板不存在');
            _this.goBack();
          });
          return;
        }
        this.config = (0, _templateStore.createDefaultEditorConfig)();
        this.pageReady = true;
        return;
      }
      this.isCreate = false;
      (0, _rsManagement.getTicketTemplateInfo)(id).then(function (res) {
        if (!res) {
          _this.$message.error('模板不存在');
          _this.goBack();
          return;
        }
        _this.config = (0, _templateStore.mapApiToEditor)(res);
        _this.pageReady = true;
      }).catch(function () {
        _this.$message.error('模板不存在');
        _this.goBack();
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;
      var name = (this.config.templateName || '').trim();
      if (!name) {
        this.$message.warning('请输入模板名称');
        return;
      }
      this.config.templateName = name;
      this.config.name = name;
      var payload = (0, _templateStore.mapEditorToApi)(this.config, {
        isCreate: this.isCreate
      });
      this.saving = true;
      var request = this.isCreate ? (0, _rsManagement.saveTicketTemplate)(payload) : (0, _rsManagement.updateTicketTemplate)(payload);
      request.then(function () {
        _this2.$closeCompletedView();
        _this2.$message.success('保存成功');
        _this2.goBack();
      }).catch(function () {}).finally(function () {
        _this2.saving = false;
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: '/rsManagement/receiptTemplate'
      });
    }
  }
};